





































import { Component, Vue, Prop } from "vue-property-decorator";
import { Entry } from "../api";
import ScreenshotDialog from "./ScreenshotDialog.vue";
import moment from "moment";

@Component({
  components: { ScreenshotDialog },
  filters: {
    typeClass(t: string) {
      switch (t) {
        case "like":
          return "success--text";
        case "dislike":
          return "error--text";
        default:
          return "";
      }
    },
    date(d: Date): string {
      if (d.toString() == `0001-01-01T00:00:00Z`) return `Nooit`;
      return moment(d).fromNow();
    }
  }
})
export default class FeedbackTable extends Vue {
  @Prop({ required: true })
  items!: Entry[];

  screenshotId = 0;

  headers = [
    { text: this.t("id"), value: "id" },
    { text: this.t("type"), value: "type" },
    { text: this.t("description"), value: "description" },
    { text: this.t("createdAt"), value: "created_at" },
    { text: this.t("representeeID"), value: "user.representee_id" },
    { text: this.t("organisationName"), value: "user.organisation_name" },
    { text: this.t("userID"), value: "user.id" },
    { text: this.t("firstName"), value: "user.first_name" },
    { text: this.t("lastName"), value: "user.last_name" },
    { text: this.t("email"), value: "user.email_address" },
    { text: "", value: "" }
  ];

  pagination = {
    descending: true,
    orderBy: "created_at"
  };

  public getType(e: Entry) {
    switch (e.type) {
      case "like":
        return this.$t("feedback.terms.like").toString();
      case "dislike":
        return this.$t("feedback.terms.dislike").toString();
      default:
        return e.type;
    }
  }

  public t(key: string): string {
    return this.$t("feedback.table." + key).toString();
  }
}
